var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    viewBox: "0 0 54 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.25C4.10786 0.25 0.75 3.60787 0.75 7.75V30.25C0.75 34.3921 4.10787 37.75 8.25 37.75H28.875C33.0171 37.75 36.375 34.3921 36.375 30.25V7.75C36.375 3.60786 33.0171 0.25 28.875 0.25H8.25Z",
    fill: "#8199F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8484 35.8749L40.125 29.1516V8.84826L46.8484 2.12491C49.2107 -0.237465 53.25 1.43568 53.25 4.77656V33.2233C53.25 36.5641 49.2107 38.2373 46.8484 35.8749Z",
    fill: "#8199F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload-video.417ede01ce86baf0ba8d053519f2ab5b.svg";
export { ForwardRef as ReactComponent };